// extracted by mini-css-extract-plugin
export default {"message":"_b33cce45","isResponsiveLayout":"_9cd96b32"};